import React, { useState } from 'react';
import { ToastTooltip } from 'components/ToastTooltip';

import { shortenText } from '../../utils/helper';

interface IShortingAddressProps {
  text: string;
  limit?: number;
}

export const ShortText = ({ text, limit = 20 }: IShortingAddressProps) => {
  const [addressHovered, setAddressHovered] = useState(false);

  return (
    <>
      <ToastTooltip
        style={{ width: '100%', paddingRight: '25px' }}
        open={addressHovered}
        message={text}
        placement="top"
      >
        <span
          onMouseEnter={() => {
            setAddressHovered(true);
          }}
          onMouseLeave={() => {
            setAddressHovered(false);
          }}
        >
          {shortenText(text, limit)}
        </span>
      </ToastTooltip>
    </>
  );
};
